module.exports = __webpack_public_path__ + "static/media/verification.ec5f22e5.png";